<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banner6">
					<div class="mendio2">
						<div class="name6">摩米贝尔，帮客户成功</div>
						<div class="Intro6">MOMI智慧自助空间系统，开店好选择</div>
					</div>
				</div>
				<div class="chainse">
					<div class="chainTs">关于我们</div>
					<div class="chainC">
						<div class="bigChain"> 
							<div class="chainCtxt">
								<div class="chainCtxt1">摩米贝尔</div>
								<div class="chainCtxt2">
									深圳摩米贝尔科技有限公司（Shenzhen Momi Bell Technology Co.,Ltd.)，是一家专注互联网+产品研发、运营、方案咨询的服务商。公司成立于2014年6月，由来自华为、腾讯、中兴、金蝶、用友的精英团队组建， 在产品研发、平台运营、解决方案、IT运维方面积累了十五年以上的经验，是客户值得放心的保障。公司坚持“用户至上 合理利润 员工发展”的宗旨，以客户成功为唯一目标，倡导以人为本的管理理念，为员工提供良好的工作环境，宽松的工作氛围，充分的培训机会以及广阔的发展空间。
								</div>
							</div>
						</div>
						<img mode="widthFix" src="../assets/images/about/map.png" class="chanPic2" />
					</div>
				</div>
				<div class="chainse">
					<div class="chainTs">公司文化</div>
					<div class="goodsBox">
						<img class="w-img" src="../assets/images/about/culture.png" />
					</div>
				</div>
				<div class="chainse">
					<div class="chainTs">公司荣耀</div>
					<div class="chsmall-box">
						<img src="../assets/images/about/r1.jpg" class="awa3"/>
						<img src="../assets/images/about/r2.jpg" class="awa3"/>
						<img src="../assets/images/about/r3.jpg" class="awa3"/>
						<img src="../assets/images/about/r4.jpg" class="awa3"/>
						<img src="../assets/images/about/r5.jpg" class="awa3"/>
						<img src="../assets/images/about/r6.jpg" class="awa3"/>
					</div>
				</div>
			</div>
			<right-cont :activeIndex="activeIndex"></right-cont>
		</div>
	</div>
</template>

<script>
import request from '../utils/request.js'	
import rightCont from '../components/rightCont.vue'
export default {
	components:{
		rightCont
	},
	data(){
		return{
			direction: 'rtl',
			activeIndex:'6',
			drawer:false,
			type:null,
			name:null,
			mobile:null,
			dialogVisible:false,
			conpany:null,
			email:null,
			address:null,
			product:null,
		}
	},
	methods:{
		handleClose(done) {
			done();
		},
		open2() {
			this.$message({
				message: '提交成功，稍后我们将会有客服人员联系您，请保持电话畅通',
				type: 'success'
			});
		 },
		async subAgent () {
			if(!this.name || !this.phone){
				this.$message({
				    message: '请输入姓名和手机号',
				    type: 'info'
				});
				return
			}
			 if (!/^1[3456789]\d{9}$/.test(this.phone)) {
					this.$message({
						message: '请填写正确的手机号',
						type: 'info'
					});
			      return;
			   }
			const res = await request({
				method:'POST', 
				url:'/soft/consult/save', 
				data:{
					name:this.name,
					mobile:this.phone,
					comp:this.conpany,
					email:this.email,
					addr:this.address,
					prod:this.product,
					type:1
				}
			})
			if(res.code!=0) return
			this.drawer = false,
			this.open2()
		}
		
	},
	mounted() {
		window.scroll(0, 0); 
	}
}
</script>

<style>
	@media screen and (min-width:600px) and (max-width:1200px) {
		.chsmall-box{
			display: flex;
		}
		.item-box{
			text-align: center;
			flex: 1;
		}
	
		.rightGo{
			width: 2.6vw;
			height: 4.8vw;
			margin-top: 2vw;
		}
		.bottom-box{
			margin-top: 6vw;
			padding: 4vw;
		}
		.bottom-text{
			font-size: 3.5vw;
			font-weight: bold;
		}
		.item3-pic{
			width: 8vw;
			height: 8vw;
		}
		.goods-pic{
			width: 11vw;
			height: 11vw;
		}
		.Intro6{
			padding:0 6vw;
			font-size: 3vw;
			text-align: center;
		}
		.goods-name{
			font-size: 4vw;
			font-weight: bold;
			color: #333;
			line-height: 8vw;
		}
		.goods-cont{
			margin-top: 4vw;
			font-size: 2.5vw;
			color: #969799;
			line-height: 4vw;
		}
		.goods-btn{
			width: 30vw;
			background-color:#155BD4;
			font-size: 3vw;
			line-height: 6vw;
			color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
		}
		.goods-conmu{
			font-size: 3vw;
			line-height: 6vw;
			color: #969799;
			margin-top: 4vw;
		}
		.goods-intro{
			font-size: 3.5vw;
			color: #333;
			line-height: 8vw;
		}
		.goods{
			width: 80vw;
			margin: 0 auto;
			padding: 5vw;
			box-shadow:0 8px 2vw 0 rgba(61,67,77,0.08);
			margin-top: 8vw;
		}
		.btn1{
			font-size: 3vw;
			text-align: center;
			width: 30vw;
			margin: 0 auto;
			height: 6vw;
			line-height: 6vw;
			background-color: #155bd4;
			color: #fff;
			margin-top:4vw;
		}
		.btn2{
			font-size: 3vw;
			text-align: center;
			width: 30vw;
			margin: 0 auto;
			height: 6vw;
			line-height: 6vw;
			border: 1px #fff solid;
			margin-top: 4vw;
		}
		.name6{
			font-size: 3vw;
			padding-top: 8vw;
			line-height: 6vw;
			text-align: center;
		}
	}

@media screen and (max-width:600px) {
	.chsmall-box{
		display: flex;
	}
	.item-box{
		text-align: center;
		flex: 1;
	}

	.rightGo{
		width: 2.4vw;
		height: 3.6vw;	
		margin-top: 3vw;
	}
	.bottom-box{
		margin-top: 6vw;
		padding: 2vw;
	}
	.bottom-text{
		font-size: 3.5vw;
		font-weight: bold;
	}
	.item3-pic{
		width: 8vw;
		height: 8vw;
	}
	.goods-pic{
		width: 11vw;
		height: 11vw;
	}
	.Intro6{
		padding:0 6vw;
		font-size: 2vw;
		text-align: center;
	}
	.goods-name{
		font-size: 4vw;
		font-weight: bold;
		color: #333;
		line-height: 8vw;
	}
	.goods-cont{
		margin-top: 4vw;
		font-size: 2.5vw;
		color: #969799;
		line-height: 4vw;
	}
	.goods-btn{
		width: 30vw;
		background-color:#155BD4;
		font-size: 2vw;
		line-height: 4vw;
		color: #fff;
		margin: 0 auto;
		margin-top: 2vw;
	}
	.goods-conmu{
		font-size: 2vw;
		line-height: 4vw;
		color: #969799;
		margin-top: 2vw;
	}
	.goods-intro{
		font-size: 3.5vw;
		color: #333;
		line-height: 8vw;
	}
	.goods{
		width: 80vw;
		margin: 0 auto;
		padding: 5vw;
		box-shadow:0 8px 2vw 0 rgba(61,67,77,0.08);
		margin-top: 8vw;
	}
	.btn1{
		font-size: 2vw;
		text-align: center;
		width: 30vw;
		margin: 0 auto;
		height: 4vw;
		line-height: 4vw;
		background-color: #155bd4;
		color: #fff;
		margin-top:2vw;
	}
	.btn2{
		font-size: 2vw;
		text-align: center;
		width: 30vw;
		margin: 0 auto;
		height: 4vw;
		line-height: 4vw;
		border: 1px #fff solid;
		margin-top: 2vw;
	}
	.name6{
		font-size: 3vw;
		padding-top: 2vw;
		line-height: 6vw;
		text-align: center;
		padding-top: 14vw;
	}
}
@media screen and (min-width:1200px) {
	.bottom-btn{
		cursor: pointer;
		background-color: #155bd4;
		width: 158px;
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		padding: 8px;
		display: block;
		margin: 0 auto;
		text-align: center;
		border-radius: 2px;
		margin-top: 24px;
	}
	.bottom-text{
		font-size: 26px;
		color: #323233;
		line-height: 36px;
	}
	.bottom-box{
		text-align: center;
		background-color: #f7f8fa;
		width: 100%;
		padding: 72px 0;
	}
	.awa3
	{
		width:180px;
		height:250px;
		margin-right:7px;
		margin-bottom: 16px;
	}
	.rightGo{
		width: 14px;
		height: 22px;	
		margin-top: 25px;
	}
	.item2-title{
		font-size: 20px;
		color: #323233;
		line-height: 28px;
		margin-bottom: 8px;
	}
	.item2-p{
		color: #969799;
		font-size: 14px;
		line-height: 20px;
	}
	.item2-pic{
		width: 32px;
		height: 32px;
		margin-bottom: 16px;
	}
	.fstSpan{
		background-image: url('../assets/images/def/date.png');
		background-size: 14px 14px;
		background-repeat: no-repeat;
		background-position: 0;
		padding-left: 20px;
		text-align: left;
		margin-left: 5px !important;
	}
	.secSpan{
		margin-left: 20px;
		background-image: url('../assets/images/def/address.png');
		background-size: 12px 16px;
		background-repeat: no-repeat;
		background-position: 0;
		padding-left: 20px;
		text-align: left;
		margin-left: 5px !important;
	}
	.knowMore{
		cursor: pointer;
	}
	.adver-text{
		display: flex;
	}
	.adver-time{
		font-size: 14px;
		color: #969799;
		line-height: 20px;
		margin-top: 2px;
		text-align: left;
	}
	.adver-title{
		flex: 1;
		font-size: 16px;
		color: #323233;
		line-height: 28px;
		text-align:left
	}
	.adver-btn{
		cursor: pointer;
		font-size: 12px;
		color: #155bd4;
		line-height: 28px;
		text-align: left;
	}
	.chanPic2
	{
		width: 485px;
	}
	.w-img
	{
		width: 1064px;
	}
	.nst{
		padding: 24px 16px !important;
		
	}
	.adver-pic{
		width: 100%;
		margin-bottom: 16px;
	}
	.st{
		margin-bottom: 8px;
	}
	.chaiIntro{
		color: #969799;
		margin-bottom: 36px;
		font-size: 20px;
		line-height: 28px;
	}
	.goods-conmu{
		color: #969799;
		font-size: 14px;
		line-height: 20px;
	}
	.goods-btn{
		cursor: pointer;
		background-color: #155bd4;
		width: 158px;
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		padding: 8px;
		display: block;
		margin: 0 auto;
		text-align: center;
		border-radius: 2px;
		margin-bottom: 10px;
	}
	.goods-cont{
		color: #969799;
		font-size: 12px;
		line-height: 20px;
		
	}
	.goods-cont.hmb{
		margin-bottom: 30px;
		height: 120px;
	}
	.goods-intro{
		font-size: 16px;
		color: #323233;
		line-height: 24px;
		margin-bottom: 30px;
	}
	.goods-name{
		font-size: 26px;
		color: #323233;
		line-height: 36px;
		margin-bottom: 4px;
	}
	.goods-pic{
		width: 72px;
		height: 72px;
		display: block;
		margin: 0 auto 24px;
	}
	.goodsBox{
		display: flex;
		background-color: rgba(200,200,200,0.15);
	}
	.goodsmal{
		padding: 48px 24px;
		
		box-shadow: 0 8px 30px 0 rgba(61,67,77,.08);
	}
	.goods{
		flex: 1;
		padding: 0 26px;
		background-color: #fff;
	}
	.Iwant{
		background-color: #155bd4;
		width: 158px;
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		padding: 8px;
		display: block;
		margin: 0 auto;
		text-align: center;
		border-radius: 2px;
	}
	.chsmall-box{
		display: flex;
	}
	.item-p{
		font-size: 16px;
		color: #646566;
		line-height: 24px;
		margin-bottom: 60px;
	}
	.item-title{
		font-size: 26px;
		color: #323233;
		line-height: 36px;
		margin-bottom: 8px;
	}
	.item-pic{
		width: 72px;
		height: 72px;
		display: block;
		margin: 0 auto 24px;
	}
	.item-box{
		text-align: center;
		flex: 1;
	}
	.chainse{
		padding: 40px;
	}
	.name6{
		font-size: 44px;
		color: #fff;
		line-height: 52px;
		margin-bottom: 16px;
		font-weight: 500;
	}
	.Intro6{
		font-size: 20px;
		color: #c8c9cc;
		line-height: 28px;
	}
	.btnBox{
		margin-top: 32px;
	}
	.btn1{
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		width: 158px;
		padding: 8px 0;
		border-radius: 2px;
		display: inline-block;
		background-color: #155bd4;
	}
	.btn2{
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		width: 158px;
		padding: 8px 0;
		border-radius: 2px;
		display: inline-block;
		padding: 7px 0;
		margin-left: 16px;
		border: 1px solid #fff;
	}
}
</style>
